/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import { Col, Tabs } from "antd"
import React, { useRef } from "react"
import { OrganizationMaintenance } from "./organization/OrganizationMaintenance";
import styles from "./maintenance.module.css"
import { TabBar } from "../../compnents/widgets/TabBar";
import { DoctorMaintenance } from "./doctor/DoctorMainTenance";

export const DataMaintenance = () => {
  const { TabPane } = Tabs;

  return (
    <Col className={styles.container}>
      <TabBar
        defaultActiveKey={"1"}
      >
        <TabPane key='1' tab='机构信息维护'>
          <OrganizationMaintenance />
        </TabPane>
        <TabPane key='2' tab='医生信息维护'>
          <DoctorMaintenance />
        </TabPane>
      </TabBar>
    </Col>
  )
}
